module.exports = __webpack_public_path__ + "static/blue-logo@2x-05cf18299b347b39c0c9fd58ae272610.png";